"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tag = void 0;
const vue_1 = require("vue");
const i18n_1 = require("../directives/i18n");
exports.Tag = vue_1.default.component('tag', {
    props: {
        tag: {
            type: String,
        },
        size: {
            type: String,
        },
        type: {
            type: String,
        },
    },
    methods: {
        getClasses: function () {
            const classes = ['tag-count'];
            const showTooltip = this.tag !== 'escape';
            if (showTooltip)
                classes.push('tooltip', 'tooltip-bottom');
            classes.push(`tag-${this.tag}`);
            if (this.size !== undefined) {
                classes.push(`tag-size-${this.size}`);
            }
            if (this.type !== undefined) {
                classes.push(`tag-type-${this.type}`);
            }
            return classes.join(' ');
        },
        getToolTip: function () {
            if (this.tag === 'escape')
                return undefined;
            return i18n_1.$t(this.tag);
        }
    },
    template: '<div :class="getClasses()" :data-tooltip="getToolTip()" />',
});
//# sourceMappingURL=Tag.js.map